import { useCallback } from 'react'
import { Input } from '../ui/Input'
import { useTranslation } from '../../contexts/LanguageContext'
import type { PersonalInfo } from '../../types/cv'

interface PersonalInfoFormProps {
  data: PersonalInfo | undefined
  onChange: (data: Partial<PersonalInfo>) => void
}

export function PersonalInfoForm({ data, onChange }: PersonalInfoFormProps) {
  const { t } = useTranslation()

  const handleChange = useCallback(
    (field: keyof PersonalInfo) => (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ [field]: e.target.value })
    },
    [onChange]
  )

  return (
    <div className="space-y-4">
      <Input
        label={t.personalInfoForm.fullName}
        placeholder={t.personalInfoForm.fullNamePlaceholder}
        value={data?.fullName || ''}
        onChange={handleChange('fullName')}
      />

      <Input
        label={t.personalInfoForm.professionalTitle}
        placeholder={t.personalInfoForm.professionalTitlePlaceholder}
        value={data?.title || ''}
        onChange={handleChange('title')}
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Input
          label={t.personalInfoForm.email}
          type="email"
          placeholder={t.personalInfoForm.emailPlaceholder}
          value={data?.email || ''}
          onChange={handleChange('email')}
        />

        <Input
          label={t.personalInfoForm.phone}
          type="tel"
          placeholder={t.personalInfoForm.phonePlaceholder}
          value={data?.phone || ''}
          onChange={handleChange('phone')}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Input
          label={t.personalInfoForm.location}
          placeholder={t.personalInfoForm.locationPlaceholder}
          value={data?.location || ''}
          onChange={handleChange('location')}
        />

        <div>
          <Input
            label={t.personalInfoForm.birthDate}
            type="date"
            value={data?.birthDate || ''}
            onChange={handleChange('birthDate')}
          />
          <p className="text-xs text-slate-400 mt-1">{t.personalInfoForm.birthDateHelper}</p>
        </div>
      </div>
    </div>
  )
}
